import React, { useState, useEffect, useRef } from 'react';
import { Glyphicon, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { Body } from './style/tile.style';
import './css/iFrameModule.css';

const BORDER_COLOURS = {
    warning: '#eea236',
    primary: '#2e6da4',
    danger: '#d43f3a',
    success: '#4cae4c',
    default: '#ccc',
    info: '#1b6d85',
};

export default function IFrameModule({ parameters }) {
    const containerRef = useRef(null);
    const ifrRef = useRef(null);

    const [containerHeight, setContainerHeight] = useState(parameters.containerHeight.container);
    const [containerWidth, setContainerWidth] = useState(100);
    const [iFrameURL, setIFrameURL] = useState(parameters.config.other_config?.iFrameURL ?? '');
    const [other_config, setOtherConfig] = useState(parameters.config.other_config ?? { allowURLChange: false, iFrameURL: '' });
    const [colour, setColour] = useState(parameters.config.colour ?? '');
    const [dragging, setDragging] = useState(false);
    const [invalidURL, setInvalidURL] = useState(null);

    useEffect(() => {
        setContainerWidth(containerRef.current.offsetWidth);
    }, []);

    useEffect(() => {
        setContainerHeight(parameters.containerHeight.container);
        setIFrameURL(parameters.config.other_config?.iFrameURL ?? '');
        setOtherConfig(parameters.config.other_config ?? { allowURLChange: false, iFrameURL: '' });
        setColour(parameters.config.colour ?? '');
    }, [parameters]);

    function handleChange(e) {
        if (e.target.name === 'iFrameURL') {
            let errorStatus = null;
            if (e.target.value.indexOf('.') !== -1) {
                if (e.target.value.length < 9) {
                    errorStatus = 'error';
                } else if (e.target.value.substring(0, 7) !== 'http://' && e.target.value.substring(0, 8) !== 'https://') {
                    errorStatus = 'error';
                }
            }
            setInvalidURL(errorStatus);
            setIFrameURL(e.target.value);
        }
    }

    function handleKeyPress(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            setOtherConfig(prev => ({ ...prev, iFrameURL }));
        }
    }

    function refresh() {
        if (ifrRef.current) ifrRef.current.src = other_config.iFrameURL;
    }

    const rowStyle = { height: containerHeight + 'px' };
    const glyphStyle = dragging ? { display: 'none' } : {};
    const formStyle = dragging ? { display: 'none' } : {};

    let outerHotSpotStyle;
    let iFrameURLDisplay = null;
    if (other_config.allowURLChange) {
        outerHotSpotStyle = { width: dragging ? '50px' : '320px', position: 'relative' };
        iFrameURLDisplay = (
            <form key="formKey" style={formStyle} className="urlForm">
                <FormGroup controlId="iFrameURLGroup" validationState={invalidURL} style={{ width: '100%' }}>
                    <FormControl type="text"
                        placeholder="URL"
                        name="iFrameURL"
                        autoFocus={true}
                        value={iFrameURL}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        style={{ width: '200px', position: 'fixed', top: 0, left: '100px', marginTop: '8px', paddingRight: '10px' }} />
                    <HelpBlock style={{ paddingLeft: '10px', backgroundColor: 'white', borderRadius: '10px' }}>
                        {invalidURL === null ? '' : 'URL must start with http:// or https://'}
                    </HelpBlock>
                    <FormControl.Feedback />
                </FormGroup>
            </form>
        );
    } else {
        outerHotSpotStyle = { width: dragging ? '50px' : '100px', position: 'relative' };
    }

    return (
        <Body className="outer-container" style={rowStyle} ref={containerRef}>
            <iframe src={other_config.iFrameURL}
                allowFullScreen={false}
                sandbox="allow-forms allow-top-navigation-by-user-activation allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts"
                ref={ifrRef}
                style={{
                    width: (containerWidth - 12) + 'px', height: (containerHeight - 12) + 'px',
                    borderStyle: 'none', position: 'absolute', top: '6px', left: '6px',
                }}>
            </iframe>
            <Draggable bounds="parent" handle=".handle" onStart={() => setDragging(true)} onStop={() => setDragging(false)}>
                <div className="outerHotSpot" style={outerHotSpotStyle}>
                    <div className="handle" style={{ height: '50px', cursor: 'move', position: 'absolute', top: 0, left: 0, zIndex: 1 }} />
                    <div className="iFrameHotSpot" style={{
                        height: '50px', borderColor: BORDER_COLOURS[colour],
                        borderWidth: '1px', position: 'absolute', top: 0, left: 0,
                    }}>
                        <Glyphicon style={glyphStyle}
                            onClick={refresh}
                            className="refresh"
                            name="refresh"
                            bsSize="large"
                            glyph="repeat" />
                        {iFrameURLDisplay}
                    </div>
                </div>
            </Draggable>
        </Body>
    );
}
